// PC-speaker style beeps via WebAudio (square wave, like the original Sound/NoSound)
export class Sound {
  constructor() {
    this.ctx = null;
    this.enabled = true;
  }

  ensure() {
    if (!this.ctx) {
      const AC = window.AudioContext || window.webkitAudioContext;
      if (AC) this.ctx = new AC();
    }
    if (this.ctx && this.ctx.state === "suspended") this.ctx.resume();
  }

  beep(freq = 700, ms = 50) {
    if (!this.enabled) return;
    try {
      this.ensure();
      if (!this.ctx) return;
      const osc = this.ctx.createOscillator();
      const gain = this.ctx.createGain();
      osc.type = "square";
      osc.frequency.value = freq;
      gain.gain.value = 0.04;
      osc.connect(gain).connect(this.ctx.destination);
      const now = this.ctx.currentTime;
      osc.start(now);
      osc.stop(now + ms / 1000);
    } catch (e) {
      if (!this.warned) {
        this.warned = true;
        console.warn("audio unavailable", e);
      }
    }
  }

  errorBeep() {
    this.beep(700, 50);
  }

  tap() {
    this.beep(900, 18);
  }
}
